import { applyTextStyles, useTheme, useThemeTokens, useViewport } from '@telus-uds/components-base';
const useTypographyTheme = (variant, tokens) => {
  const viewport = useViewport();
  const themeTokens = useThemeTokens('Typography', tokens, variant, {
    viewport
  });
  const {
    themeOptions
  } = useTheme();
  const {
    fontSize,
    lineHeight,
    ...rnStyles
  } = applyTextStyles({
    ...themeTokens,
    themeOptions
  });
  return {
    ...rnStyles,
    fontSize: `${fontSize}px`,
    lineHeight: `${lineHeight}px`
  };
};
export default useTypographyTheme;